import Seo from "../components/Seo";

const PRIVACY = [
  ["What we collect", "When you submit an enquiry through this website we collect the details you provide: your name, email address, phone number, project address or suburb, project details and any files you choose to upload (such as plans, drawings or photos)."],
  ["How we use it", "Your information is used only to respond to your enquiry, discuss your project, prepare pricing and carry out building work you engage us for. Uploaded files are stored securely in private cloud storage and are only accessible to Razor Build."],
  ["Sharing", "We do not sell or share your personal information with third parties for marketing. Information may be shared with subcontractors, designers or engineers only where it is needed to price or deliver your project."],
  ["Storage and security", "Enquiry details and uploaded files are held on secure servers. Download links sent by email expire after 14 days. You can ask us to delete your enquiry and any uploaded files at any time by emailing razorbuild@outlook.com."],
  ["Your rights", "Under the Privacy Act 2020 (NZ) you may ask to see, correct or delete the personal information we hold about you. Contact razorbuild@outlook.com and we will action your request promptly."],
];

const TERMS = [
  ["General", "This website is provided by Razor Build Limited to provide information about our residential building services and to receive project enquiries. By using this website you accept these terms."],
  ["Information only", "Content on this website is general information and does not constitute a quote, contract or building advice for your specific property. Any building work is subject to a separate written agreement between you and Razor Build Limited."],
  ["Enquiries and uploads", "When you submit an enquiry or upload files, you confirm the information is yours to provide and accurate to the best of your knowledge. Please do not upload files you do not have the right to share."],
  ["Intellectual property", "The Razor Build name, logo and website content are the property of Razor Build Limited and may not be reproduced without permission."],
  ["Liability", "We take care to keep this website accurate and available, but provide it as-is and are not liable for any loss arising from use of the website or reliance on its content."],
];

export default function Legal({ page }) {
  const isPrivacy = page === "privacy";
  const sections = isPrivacy ? PRIVACY : TERMS;
  return (
    <>
      <Seo
        title={isPrivacy ? "Privacy Policy — Razor Build Limited" : "Terms & Conditions — Razor Build Limited"}
        description={isPrivacy ? "How Razor Build Limited collects, uses and protects your personal information." : "Terms and conditions for using the Razor Build Limited website."}
      />
      <section className="pt-32 md:pt-40 pb-10 bg-ink">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 pb-10">
          <h1 className="font-display font-bold text-3xl md:text-5xl tracking-tight text-white display-expanded">
            {isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
          </h1>
        </div>
      </section>
      <section className="py-14 md:py-20 bg-paper">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 space-y-10">
          {sections.map(([title, body]) => (
            <div key={title} data-testid={`legal-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <h2 className="font-display font-semibold text-xl text-ink">{title}</h2>
              <p className="mt-3 text-sm md:text-base text-slate2 leading-relaxed">{body}</p>
            </div>
          ))}
          <p className="text-xs text-slate2/70 pt-4 border-t border-line">Last updated: July 2026 · Razor Build Limited, Wellington Region, New Zealand</p>
        </div>
      </section>
    </>
  );
}
